import { render, staticRenderFns } from "./tablePosition.vue?vue&type=template&id=677f755c&"
import script from "./tablePosition.vue?vue&type=script&lang=js&"
export * from "./tablePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports